export default "__VITE_ASSET__BHZxZmnk__"